// CmcUsageWidget/CmcUsageCalculator.js
// Static class — Noun.Verb methods (Development.Patterns rk=a786510f).
// Normalizes raw CmcUsageItemDto items and derives the widget's render-state from them.
import cmcUsageConst from './cmcUsageConst';

const { RK, BANDS } = cmcUsageConst;

class CmcUsageCalculator {
    /**
     * @param {{rk:string,value:string,order:number,visible:boolean,ems:number}[]} items - cached, normalized items
     * @returns {object|null} render-state for the widget, or null if empty
     */
    static buildState(items) {
        if (!items?.length) return null;

        const byRk = (rk) => items.find((i) => i.rk === rk) ?? null;
        const numValue = (rk) => {
            const item = byRk(rk);
            return item ? Number(item.value) : null;
        };

        const monthUsed = numValue(RK.MONTH_CREDITS_USED);
        const monthLimit = numValue(RK.CREDIT_LIMIT_MONTHLY);
        const monthLeft = numValue(RK.MONTH_CREDITS_LEFT);
        const monthPct = monthLimit ? Math.round((monthUsed / monthLimit) * 100) : 0;

        const dayUsed = numValue(RK.DAY_CREDITS_USED);
        const dayLeft = numValue(RK.DAY_CREDITS_LEFT);
        const dayLimit = dayUsed != null && dayLeft != null ? dayUsed + dayLeft : null;
        const dayPct = dayLimit ? Math.round((dayUsed / dayLimit) * 100) : 0;

        const lastUpdatedItem = byRk(RK.MONTH_CREDITS_USED) ?? items[0];

        return {
            month: { used: monthUsed, left: monthLeft, limit: monthLimit, pct: monthPct, band: CmcUsageCalculator.getBand(monthPct) },
            day: { used: dayUsed, left: dayLeft, pct: dayPct, band: CmcUsageCalculator.getBand(dayPct), depleted: dayLeft === 0 },
            rateLimitPerMinute: numValue(RK.RATE_LIMIT_MINUTE),
            minuteRequestsUsed: numValue(RK.MINUTE_REQUEST_USED),
            minuteRequestsLeft: numValue(RK.MINUTE_REQUESTS_LEFT),
            monthlyReset: byRk(RK.CREDIT_LIMIT_MONTHLY_RESET)?.value ?? null,
            lastUpdated: lastUpdatedItem?.ems ?? null,
        };
    }

    /**
     * @param {number} pct - 0-100
     * @returns {{max:number,label:string,color:string}}
     */
    static getBand(pct) {
        return BANDS.find((b) => pct <= b.max) ?? BANDS[BANDS.length - 1];
    }
}

export default CmcUsageCalculator;
